module.exports = __webpack_public_path__ + "static/img_2108-225907f855252de3cb6ec3f2e08ec078.webp";